<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <b-form>
          <b-form-group
            label="Nombre"
            label-for="nombre"
            :label-cols="1"
            horizontal>
            <b-form-input id="nombre" 
              v-model= "nombre" 
              type="text">
            </b-form-input>
          </b-form-group>
        </b-form>
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <b-table hover  
            responsive="sm" 
            class="registro"
            :busy="tableBusy"
            :items="impuestos" 
            :fields="fields"
            :filter="nombre"
            :current-page="paginaActual"
            :per-page="registrosPorPagina"
            @filtered="onFiltered"
            @row-clicked="seleccionarImpuesto">
          <div slot="table-busy" class="text-center">
            <b-spinner class="table-spinner" label="Spinning" />
          </div>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" xl="12">  
        <nav>
          <b-pagination size="sm" 
            :total-rows="totalRegistros" 
            :per-page="registrosPorPagina" 
            v-model="paginaActual" 
            prev-text="Prev." next-text="Prox."/>
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  name: 'ImpuestosSearchList',
  props: {
    proveedor: {
      type: Object,
      default: null
    },
  },
  data: () => {
    return {
      impuestos: [],
      fields: [],

      loaded: false,
      tableBusy: false,

      /* Info de paginación */
      paginaActual: 1,
      totalPaginas: 1,
      registrosPorPagina: 5,
      totalRegistros: 0,

      proveedorId: 0,
      nombre: null,
    }
  },
  computed: {
  },
  created() {
    this.proveedorId = 0;
    if (this.proveedor) {
      if (this.proveedor.id) {
        this.proveedorId = this.proveedor.id;
      }
    }

    if (this.proveedorId != 0) {
      this.fields = [
        // {
        //   key: 'id',
        //   label: 'Cód.'
        // },
        {
          key: 'nombre',
          sortable: true
        },
      ]
    } else {
      this.fields = [
        // {
        //   key: 'id',
        //   label: 'Cód.'
        // },
        {
          key: 'impuestoOrganismo',
          label: 'Organismo',
          sortable: true
        },
        {
          key: 'nombre',
          sortable: true
        },
      ]
    }


    this.getItems();
  },  
  methods: {
    getItems() {
      let params = {
        impuestos: true
      }

      this.tableBusy = true;
      this.$store.dispatch('proveedores/getList', params)
        .then(() => {
          this.impuestos = this.$store.getters['proveedores/list'];
          this.totalRegistros = this.impuestos.length;
          this.tableBusy = false;
        })
    },
    seleccionarImpuesto (item) {
      this.$emit('impuestoSeleccionado', item)
    },
    onFiltered(filteredItems) {
      this.totalRegistros = filteredItems.length
      this.paginaActual = 1
    }    
  },
}
</script>

<style>
</style>
